export const IP_PRICING_DATA = [
  {
    name: "Public IPv4",
    count: "1 - ∞",
    pricePerHour: "$0.0050",
    pricePerMonth: "$3.60",
  },
  {
    name: "Public IPv6",
    count: "1 - ∞",
    pricePerHour: "FREE",
    pricePerMonth: "FREE",
  },
];

export const FOOTER_CONSTANTS = {
  btnText: "Provision IP Now ",
};
